import PropTypes from 'prop-types'
import React from 'react'
import { owlAddJsError } from '../../common/utils/owl'

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: null,
  }

  componentDidCatch (error, errorInfo) {
    const e = { error, ...errorInfo }
    console.log('ErrorBoundary Catch:', e.componentStack)
    // 主动上报
    owlAddJsError('ErrorBoundary Catch:', e)
    // 自定义处理
    this.props.onError && this.props.onError(e)
  }

  // 从错误中映射状态对象
  static getDerivedStateFromError (error) {
    return {
      hasError: true,
      error,
    }
  }

  render () {
    if (this.state.hasError) {
      return this.props.fallback
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  fallback: PropTypes.node,
  onError: PropTypes.func,
  children: PropTypes.element,
}
export default ErrorBoundary
